export default "<section class=\"payment-container\">\r\n    <app-payment-choose-plan></app-payment-choose-plan>\r\n</section>";